import { BUS_FETCH_TRANSACTION_LIST } from '../actions/fetchTransactionListAction';
import { LOGOUT_ACTION } from 'modules/general/shared/action/logout';
import { BUS_TRANSACTION_LIST_RESET_FILTERS } from '../actions/resetFiltersAction';

const initialState = {
  status: 'NOT_INITIALIZED',
  errorTitle: '',
  errorMessage: '',
  inventories: [],
  originLabel: '',
  destinationLabel: '',
  agentId: null,
  startDate: null,
  endDate: null,
  disableFetch: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case BUS_FETCH_TRANSACTION_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case LOGOUT_ACTION:
      return initialState;
    case BUS_TRANSACTION_LIST_RESET_FILTERS:
      return {
        ...state,
        agentId: null,
        startDate: null,
        endDate: null,
      };
    default:
      return state;
  }
}
